// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see SystemOpenNotificationSettingsEvent
 */
export var SystemOpenNotificationSettings = function (_a) {
    var origin = _a.origin;
    return ({
        name: "System Open NotificationSettings",
        parameters: {
            cdf_entity: "System",
            cdf_action: "Open",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
